/*
 * Grow compliance gate.
 * The buyer must acknowledge the terms and the privacy policy before checkout.
 * Guards BOTH cart surfaces: the cart page form (#cart) and the cart drawer
 * form (#CartDrawer-Form), plus any dynamic/accelerated checkout buttons the
 * theme may render in the cart.
 *
 * Two independent locks, on purpose:
 *   1. the `disabled` attribute on the checkout button (visible affordance)
 *   2. capture-phase preventDefault on click AND submit, so a keyboard Enter
 *      or a programmatic requestSubmit() is blocked as well.
 *
 * The theme itself disables the checkout button while the cart is empty. We
 * never undo that: we only remove `disabled` from buttons we ourselves marked
 * with data-sofit-disabled. Net rule: open only if (cart not empty) AND (checked).
 */
(function () {
  'use strict';

  var FORM_IDS = ['cart', 'CartDrawer-Form'];
  var WALLET_SELECTOR = '.cart__dynamic-checkout-buttons, .additional-checkout-buttons';
  var CHECKOUT_SELECTOR = 'button[name="checkout"], input[name="checkout"]';

  // Survives AJAX section re-renders (Dawn replaces the cart markup on qty
  // change) but intentionally resets on a real page load.
  var agreed = false;

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function gates() {
    return toArray(document.querySelectorAll('[data-sofit-terms-gate]'));
  }

  function ownerFormId(btn) {
    var id = btn.getAttribute('form');
    if (id) return id;
    var form = btn.closest('form');
    return form ? form.id : null;
  }

  function checkoutButtons() {
    return toArray(document.querySelectorAll(CHECKOUT_SELECTOR)).filter(function (btn) {
      return FORM_IDS.indexOf(ownerFormId(btn)) !== -1;
    });
  }

  function walletContainers() {
    return toArray(document.querySelectorAll(WALLET_SELECTOR));
  }

  function showError(gate) {
    var err = gate.querySelector('[data-sofit-terms-error]');
    if (err) err.removeAttribute('hidden');
  }

  function hideError(gate) {
    var err = gate.querySelector('[data-sofit-terms-error]');
    if (err) err.setAttribute('hidden', '');
  }

  function sync() {
    gates().forEach(function (gate) {
      var cb = gate.querySelector('[data-sofit-terms-checkbox]');
      if (cb && cb.checked !== agreed) cb.checked = agreed;
      if (agreed) hideError(gate);
    });

    checkoutButtons().forEach(function (btn) {
      if (agreed) {
        // Only re-enable what WE disabled. A button the theme disabled because
        // the cart is empty stays disabled.
        if (btn.hasAttribute('data-sofit-disabled')) {
          btn.removeAttribute('disabled');
          btn.removeAttribute('data-sofit-disabled');
        }
        btn.removeAttribute('aria-disabled');
      } else {
        if (!btn.hasAttribute('disabled')) {
          btn.setAttribute('disabled', '');
          btn.setAttribute('data-sofit-disabled', '');
        }
        btn.setAttribute('aria-disabled', 'true');
      }
    });

    walletContainers().forEach(function (el) {
      el.classList.toggle('sofit-terms-gate--blocked', !agreed);
    });
  }

  function firstGate() {
    return gates()[0] || null;
  }

  function block(e) {
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    var gate = firstGate();
    if (!gate) return;
    gates().forEach(showError);
    var cb = gate.querySelector('[data-sofit-terms-checkbox]');
    if (cb && typeof cb.focus === 'function') cb.focus();
  }

  function isGuardedTarget(node) {
    if (!node || typeof node.closest !== 'function') return false;
    var btn = node.closest(CHECKOUT_SELECTOR);
    if (btn) return FORM_IDS.indexOf(ownerFormId(btn)) !== -1;
    return !!node.closest(WALLET_SELECTOR);
  }

  document.addEventListener('click', function (e) {
    if (agreed) return;
    if (!gates().length) return;
    if (!isGuardedTarget(e.target)) return;
    block(e);
  }, true);

  document.addEventListener('submit', function (e) {
    if (agreed) return;
    var form = e.target;
    if (!form || FORM_IDS.indexOf(form.id) === -1) return;
    if (!gates().length) return;
    block(e);
  }, true);

  document.addEventListener('change', function (e) {
    var node = e.target;
    if (!node || typeof node.closest !== 'function') return;
    if (!node.closest('[data-sofit-terms-checkbox]')) return;
    agreed = !!node.checked;
    sync();
  }, true);

  var pending = false;
  function scheduleSync() {
    if (pending) return;
    pending = true;
    // setTimeout, not requestAnimationFrame: rAF is throttled/paused while the
    // tab is hidden, which would delay re-locking the button after a cart
    // re-render in a background tab.
    setTimeout(function () {
      pending = false;
      sync();
    }, 0);
  }

  function start() {
    sync();
    // Dawn swaps the whole cart section on quantity changes; re-apply after it.
    // childList only, so our own attribute writes cannot retrigger this.
    new MutationObserver(scheduleSync).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
